export class PipelineHistoryEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "recordedAt",
            "baseName": "recordedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "kind",
            "baseName": "kind",
            "type": "PipelineHistoryKind",
            "format": ""
        },
        {
            "name": "actorId",
            "baseName": "actorId",
            "type": "string",
            "format": ""
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "Array<PipelineHistoryField>",
            "format": ""
        },
        {
            "name": "changes",
            "baseName": "changes",
            "type": "Array<PipelineHistoryFieldChange>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PipelineHistoryEntry.attributeTypeMap;
    }
    constructor() {
    }
}
